// src/pages/PasswordResetSuccessScreen.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowRight,
  Check,
  CheckCircle2,
  KeyRound,
  LockKeyhole,
  LogIn,
  ShieldCheck,
  Sparkles,
} from "lucide-react";

import "../sass/pages/passwordResetSuccess.scss";
import Logo from "../assets/logo.webp";

const PasswordResetSuccessScreen = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/login", {
      replace: true,
    });
  };

  return (
    <main className="psy-prs-page">
      <div
        className="psy-prs-background"
        aria-hidden="true"
      >
        <span className="psy-prs-background__orb psy-prs-background__orb--one" />
        <span className="psy-prs-background__orb psy-prs-background__orb--two" />
        <span className="psy-prs-background__grid" />
      </div>

      <div className="psy-prs-layout">
        <aside className="psy-prs-aside">
          <div className="psy-prs-brand">
            <img
              src={Logo}
              alt="PsyAssist Pro"
            />

            <div>
              <strong>
                PsyAssist Pro
              </strong>

              <span>
                Segurança para sua conta
              </span>
            </div>
          </div>

          <div className="psy-prs-aside__content">
            <span className="psy-prs-kicker">
              <Sparkles size={15} />
              Recuperação concluída
            </span>

            <h1>
              Seu acesso está pronto para
              continuar.
            </h1>

            <p>
              A nova senha foi registrada e
              já pode ser utilizada no próximo
              login do PsyAssist Pro.
            </p>

            <div className="psy-prs-assurances">
              <div className="psy-prs-assurance">
                <span>
                  <KeyRound size={19} />
                </span>

                <div>
                  <strong>
                    Nova senha cadastrada
                  </strong>

                  <small>
                    Utilize a credencial criada
                    na etapa anterior para entrar.
                  </small>
                </div>
              </div>

              <div className="psy-prs-assurance">
                <span>
                  <ShieldCheck size={19} />
                </span>

                <div>
                  <strong>
                    Fluxo concluído
                  </strong>

                  <small>
                    O processo de recuperação foi
                    finalizado com sucesso.
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="psy-prs-security-card">
            <div>
              <LockKeyhole size={19} />
            </div>

            <p>
              <strong>
                Mantenha sua conta protegida
              </strong>

              Não compartilhe sua senha e evite
              reutilizá-la em outros serviços.
            </p>
          </div>
        </aside>

        <section className="psy-prs-panel">
          <div className="psy-prs-progress">
            <div className="psy-prs-progress__header">
              <span>
                Recuperação de acesso
              </span>

              <strong>
                Concluída
              </strong>
            </div>

            <div
              className="psy-prs-progress__track"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow="100"
              aria-label="Progresso da recuperação de senha"
            >
              <span />
            </div>
          </div>

          <section
            className="psy-prs-status"
            aria-live="polite"
          >
            <div className="psy-prs-status__visual">
              <div className="psy-prs-status__rings">
                <span />
                <span />
              </div>

              <div className="psy-prs-status__icon">
                <CheckCircle2
                  size={36}
                  aria-hidden="true"
                />
              </div>
            </div>

            <span className="psy-prs-status__badge">
              Senha redefinida
            </span>

            <h2>
              Tudo certo com sua nova senha
            </h2>

            <p>
              Retorne ao login e utilize a nova
              credencial para acessar seu
              workspace.
            </p>
          </section>

          <div className="psy-prs-steps">
            <div className="psy-prs-step psy-prs-step--done">
              <div className="psy-prs-step__icon">
                <Check size={16} />
              </div>

              <div>
                <strong>
                  Código confirmado
                </strong>

                <span>
                  Sua identidade foi validada.
                </span>
              </div>
            </div>

            <div className="psy-prs-step psy-prs-step--done">
              <div className="psy-prs-step__icon">
                <Check size={16} />
              </div>

              <div>
                <strong>
                  Senha atualizada
                </strong>

                <span>
                  A nova credencial foi salva.
                </span>
              </div>
            </div>

            <div className="psy-prs-step psy-prs-step--current">
              <div className="psy-prs-step__icon">
                <LogIn size={16} />
              </div>

              <div>
                <strong>
                  Próximo acesso
                </strong>

                <span>
                  Entre novamente no sistema.
                </span>
              </div>
            </div>
          </div>

          <section className="psy-prs-next">
            <div className="psy-prs-next__icon">
              <LogIn size={20} />
            </div>

            <div>
              <span>
                Próxima ação
              </span>

              <strong>
                Acesse sua conta com a nova senha
              </strong>

              <p>
                Na tela de login, informe seu
                e-mail e a senha que acabou de
                cadastrar.
              </p>
            </div>
          </section>

          <button
            type="button"
            className="psy-prs-primary"
            onClick={handleGoToLogin}
          >
            Ir para o login
            <ArrowRight size={18} />
          </button>

          <footer className="psy-prs-footer">
            <ShieldCheck size={14} />

            <p>
              Sua senha não é exibida nem
              armazenada nesta página.
            </p>
          </footer>
        </section>
      </div>
    </main>
  );
};

export default PasswordResetSuccessScreen;
